const resultsData = [
    {
        title: 'Lesgeven in het PO',
        subText: 'Wat is lesgeven op het PO',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/PO',
        tags: ['po', 'assistant'],
    },
    {
        title: 'Lesgeven in het VO',
        subText: 'Wat is lesgeven op het VO',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/VO',
        tags: ['vo'],
    },
    {
        title: 'Lesgeven in het MBO',
        subText: 'Wat is lesgeven op het MBO',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/MBO',
        tags: ['mbo'],
    },
    {
        title: 'Lesgeven in het HBO',
        subText: 'Wat is lesgeven op het HBO',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/HBO',
        tags: ['hbo'],
    },
    {
        title: 'Lesgeven in het SO',
        subText: 'Wat is lesgeven op het SO',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/SO',
        tags: ['so'],
    },
    {
        title: 'Gastdocent',
        subText: 'Wat doet een gastdocent?',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Gastdocent',
        tags: ['teacher', 'hybrid'],
    },
    {
        title: 'Zijinstroom in het onderwijs',
        subText: 'Hoe werkt zij instromen',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Zij-instroomtraject-maatwerk',
        tags: ['full-switch'],
    },
    {
        title: 'Deeltijd in het onderwijs',
        subText: 'Wat houd deeltijd in?',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Deeltijdtraject',
        tags: ['full-switch'],
    },
    {
        title: 'Hybride docentschap en gastlessen',
        subText: 'Wat  levert het op?',
        link:
            'https://fontys.mediamission.nl/Mediasite/Play/9ad5e0fed4864bce9432ba0cd876fcc41d',
        tags: ['hybrid'],
    },
    {
        title: 'Passie voor techniek?',
        subText: 'Zij-instroomtraject techniek',
        link: 'https://youtu.be/ie-BqTHcsBc?feature=shared',
        tags: ['hybrid'],
    },
    {
        title: 'Wat doet een instructeur?',
        subText: 'lesgeven als instructeur',
        link: 'https://www.grijpjekansinhetonderwijs.nl/instructeur',
        tags: ['instructor'],
    },
    {
        title: 'Ondersteunen in het onderwijs',
        subText: 'lesgeven als instructeur',
        link:
            'https://www.grijpjekansinhetonderwijs.nl/ondersteunen-in-het-onderwijs',
        tags: ['instructor'],
    },
];

export default resultsData;

// export const data = {
//     po: [
//         {
//             title: 'Lesgeven in het PO',
//             subText: 'Wat is lesgeven op het PO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/PO',
//         },
//     ],
//     vo: [
//         {
//             title: 'Lesgeven in het VO',
//             subText: 'Wat is lesgeven op het VO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/VO',
//         },
//     ],
//     mbo: [
//         {
//             title: 'Lesgeven in het MBO',
//             subText: 'Wat is lesgeven op het MBO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/MBO',
//         },
//     ],
//     hbo: [
//         {
//             title: 'Lesgeven in het HBO',
//             subText: 'Wat is lesgeven op het HBO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/HBO',
//         },
//     ],
//     so: [
//         {
//             title: 'Lesgeven in het SO',
//             subText: 'Wat is lesgeven op het SO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/SO',
//         },
//     ],
//     'full-switch': [
//         {
//             title: 'Zijinstroom in het onderwijs',
//             subText: 'Hoe werkt zij instromen',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Zij-instroomtraject-maatwerk',
//         },
//         {
//             title: 'Deeltijd in het onderwijs',
//             subText: 'Wat houd deeltijd in?',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Deeltijdtraject',
//         },
//     ],
//     hybrid: [
//         {
//             title: 'Gastdocent',
//             subText: 'Wat doet een gastdocent?',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Gastdocent',
//         },
//         {
//             title: 'Hybride docentschap en gastlessen',
//             subText: 'Wat  levert het op?',
//             link:
//                 'https://fontys.mediamission.nl/Mediasite/Play/9ad5e0fed4864bce9432ba0cd876fcc41d',
//         },
//         {
//             title: 'Passie voor techniek?',
//             subText: 'Zij-instroomtraject techniek',
//             link: 'https://youtu.be/ie-BqTHcsBc?feature=shared',
//         },
//     ],
//     teacher: [
//         {
//             title: 'Gastdocent',
//             subText: 'Wat doet een gastdocent?',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/normal-button-popup/Gastdocent',
//         },
//     ],
//     assistant: [
//         {
//             title: 'Lesgeven in het PO',
//             subText: 'Wat is lesgeven op het PO',
//             link:
//                 'https://www.grijpjekansinhetonderwijs.nl/carriereswitch/button-popup/PO',
//         },
//     ],
// };
